import React, { useCallback,useState, useEffect } from "react";
import UnconfiguredComponent from '../common3/UnconfiguredComponent'


 const Clone = (props) => {

  const { extra = {} } = props;
  const { cloneId = null } = extra

  let hint= `Clone will include ${cloneId} in this section`
  let  icon = 'fad fa-clone'

  if( ! cloneId ) {
    hint = 'Add id of component to clone'
  }

  return <UnconfiguredComponent icon={icon} label="Clone" hint={hint}/>

  
};

export default Clone